import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-warm-white font-body text-warm-gray-900" data-id="element-153">
      <ScrollToTop data-id="element-154" />
      <Header data-id="element-155" />
      <main className="flex-grow pt-20" data-id="element-156">{children}</main>
      <Footer data-id="element-157" />
    </div>;
}